/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import React, { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import createIcon from '../../../../static/img/createIcon.svg';
import { API_URL } from '../../../../utils/constants';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function IngredientsList(): React.ReactElement {
  const stateRef = useRef(null);
  const history = useHistory();
  const url = `${API_URL}/products/ingredients/get`;
  const StatefullGrid = withState(Grid, url);

  const productNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/ingredients/edit/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Ingredients"
        titleRight="Create"
        onRightHandler={(): void => history.push('/ingredients/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="name" title="Ingredient Name" cell={(row) => productNameCell(row, stateRef)} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
